interface DataLayerObject {
  [key: string]: number | string | boolean | string[];
}

export function gtagEnvelope(type: string, name: string, dataLayerObject: DataLayerObject) {
  if (typeof window.gtag !== 'function') {
    console.warn('GTM not available. dataLayer.push attemted:', type, name, dataLayerObject);
  } else {
    window.gtag(type, name, dataLayerObject);
  }
}
